import { IListing } from "../../@types/listing";
import { BaseIntegration } from "../types/base";
import { countIntegrationServices } from "../utils";
import { KnockFactory } from './factory';
import { KnockServices } from "./types";
import { serializeIntegration } from '../utils/index';

export default class Knock implements BaseIntegration<KnockServices> {
  services: KnockServices;
  factory: KnockFactory;

  constructor(listing: IListing) {
    this.factory = new KnockFactory(listing);
    this.services = this.factory.create();
  }

  count() {
    return countIntegrationServices(this.services);
  }

  serialize() {
    return serializeIntegration(this);
  }
}
